import React from 'react';
import { formatCurrency } from 'utils';
import { Box, Stack } from '@mui/material';
import { FormInput } from 'components/form';
import { BasePrice } from 'modules/equipment/types';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing/types';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { CHARGE_ROW_HEIGHT } from '../../../../../constants/form';
import { QuoteChargeListingEntity, QuoteChargeType } from '../../../../../types';

interface Props {
  rowIndex: number;
  type: keyof Pick<BasePrice, 'netPrice' | 'retailPrice'>;
  priceCalc: QuoteChargeListingEntity[];
}

export const ReadOnlyValueCell = ({ type, rowIndex, priceCalc }: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();

  const { type: cellType } = useWatch({ control, name: `bodyFields.${rowIndex}` });

  const calcEntity = priceCalc[rowIndex];
  const charge = calcEntity?.charge;
  const equipment = calcEntity?.equipment;

  const renderWithAttachments = cellType === QuoteChargeType.Equipment && !!equipment?.attachments?.length;

  const renderCellContentByType: Record<QuoteChargeType, any> = {
    [QuoteChargeType.Invoice]: (
      <RenderWithCondition condition={!!charge}>
        <FormInput variant="outlined" disabled value={formatCurrency(charge?.price[type] ?? null, true)} />
      </RenderWithCondition>
    ),
    [QuoteChargeType.Equipment]: (
      <Stack width="100%" height="100%" gap="0.5rem">
        <Box sx={{ paddingBottom: renderWithAttachments ? '2.5rem' : 0 }}>
          <FormInput variant="outlined" disabled value={formatCurrency(equipment?.price[type] ?? null, true)} />
        </Box>

        <RenderWithCondition condition={renderWithAttachments}>
          {equipment?.attachments?.map((attachment, index) => (
            <Box height={CHARGE_ROW_HEIGHT}>
              <FormInput
                disabled
                key={index}
                variant="outlined"
                value={formatCurrency(attachment.price[type] ?? null, true)}
              />
            </Box>
          ))}
        </RenderWithCondition>
      </Stack>
    ),
  };

  return <>{renderCellContentByType[cellType]}</>;
};
